// Tooltip positioning constants
export const TIMEOUT_VALUE = 0;
export const TOP_OFFSET_VALUE = 15;
export const LEFT_OFFSET_VALUE = -1;

// Default legend statuses
export const DEFAULT_LEGEND_STATUSES = [
  {
    textKey: "shared.legend.inProgress",
    color: "#cbd5e0",
    pulse: true,
    tag: "INPROGRESS",
  },
  {
    textKey: "shared.legend.active",
    color: "#68d391",
    tag: "ACTIVE",
  },
  {
    textKey: "shared.legend.completed",
    color: "#68d391",
    tag: "COMPLETED",
  },
  {
    textKey: "shared.legend.disabled",
    color: "#fc8181",
    tag: "DISABLED",
  },
  {
    textKey: "shared.legend.failed",
    color: "#fc8181",
    tag: "FAILED",
  },
];
